module.exports = __webpack_public_path__ + "img/799.9e462035.jpg";